import { FC, useEffect, useState } from 'react';
import { Col, Row, Typography } from 'antd';
import { TbArrowUpRight, TbDownload } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { ExportDataDropdown } from '@/shared';

// interface DownloadAccountInformationProps {}

const DownloadAccountInformation: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <Row align='top'>
            <Col flex='auto'>
                <Typography.Title id='settings-account-security-download' level={4}>
                    <TbDownload style={{ marginRight: '0.5rem', verticalAlign: '-0.1rem' }} />
                    Account & Workspace Data Export
                </Typography.Title>
                <small>
                    <span style={{ color: token.colorTextTertiary }}>
                        Workspace admins and owners receive workspace-wide exports; other members receive their owned or
                        authored data. Some sensitive materials are excluded from data exports. Learn more in our{' '}
                    </span>
                    <a href='http://countercyclical.io/privacy' target='_blank' rel='noopener noreferrer'>
                        privacy policy
                        <TbArrowUpRight style={{ verticalAlign: '-0.1rem', marginLeft: '0.125rem' }} />
                    </a>
                </small>
            </Col>
            <Col flex='none' style={{ textAlign: 'right' }}>
                <ExportDataDropdown />
            </Col>
        </Row>
    );
};

export default DownloadAccountInformation;
